import {
  Delete as DeleteIcon,
  DragIndicator as DragIndicatorIcon,
  Edit as EditIcon,
  FileCopy as FileCopyIcon,
  Image as ImageIcon,
  Info as InfoIcon,
} from "@mui/icons-material";
import { Divider, Theme } from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 8,
    marginBottom: 8,
    border: "2px dotted transparent",
    "&:hover": {
      borderColor: colors.gray,
    },
    "&:hover .edit-icons-container": {
      visibility: "visible",
    },
    "&:hover .styled-drag-indicator": {
      visibility: "visible",
    },
  },
  body: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  edit: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.light,
    padding: 14,
    width: "100%",
    marginRight: 12,
    marginLeft: 12,
  },
  editFooter: {
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    paddingTop: 8,
    paddingBottom: 8,
    width: "100%",
  },
  editButtons: {
    display: "flex",
    flexDirection: "row",
    marginLeft: 8,
    lineHeight: 8,
    alignItems: "center",
  },
  dateFormatButton: {
    border: "1px solid #7D8797",
    color: colors.gray,
    marginRight: 4,
  },
  selectedDateFormatButton: {
    border: "2px solid #1FD4AF",
    color: colors.primary,
    marginRight: 4,
  },
  saveChangesButton: {
    marginLeft: 8,
  },
  subHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 8,
  },
  content: {
    display: "flex",
    backgroundColor: colors.gray,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: theme.typography.pxToRem(150),
    marginRight: 8,
    marginBottom: 8,
    marginLeft: 8,
  },
  columnContent: {
    display: "flex",
    flexDirection: "column",
    padding: 8,
    width: "100%",
  },
  longTextInputContent: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    width: "100%",
    marginRight: 8,
    marginLeft: 14,
  },
  editIcons: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 4,
    visibility: "hidden",
  },
  dragging: {
    opacity: 0,
  },
  imagPreview: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  formattingIcons: {
    color: colors.gray,
    height: theme.typography.pxToRem(24),
    weight: theme.typography.pxToRem(24),
  },
  formattingIconsActive: {
    color: colors.primary,
  },
  formattingIconsInActive: {
    color: colors.gray,
  },
  formattingIconsContainer: {
    marginRight: theme.spacing(4),
    marginLeft: theme.spacing(4),
  },
  multilineTextfieldContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(1),
    width: "100%",
  },
  textEditor: {
    display: "flex",
    backgroundColor: "#ecf0f6",
    width: "100%",
    height: 50,
    padding: theme.spacing(2),
    alignItems: "center",
  },
  editorContent: {
    display: "flex",
    flexDirection: "column",

    "& .ProseMirror": {
      flex: 1,
      fontSize: 16,
    },

    "& .ProseMirror:focus": {
      outline: "none",
    },

    "& .ProseMirror-selectednode": {
      outline: "3px solid #68cef8",
    },
    padding: 8,
    height: "100%",
  },
  descriptionTextEditor: {
    width: "100%",
    backgroundColor: colors.white,
    minHeight: 150,
  },
  headerTextEditor: {
    width: "100%",
    backgroundColor: colors.white,
  },
  img: {
    maxHeight: 300,
    maxWidth: 300,
  },
}));

export const StyledDragIndicatorIcon = withStyles(
  DragIndicatorIcon,
  (theme) => ({
    root: {
      color: colors.primary,
      visibility: "hidden",
    },
  })
);

export const StyledInfoIcon = withStyles(InfoIcon, (theme) => ({
  root: {
    color: colors.primary,
    marginTop: 6,
  },
}));

export const StyledEditIcon = withStyles(EditIcon, (theme) => ({
  root: {
    color: colors.primary,
    marginTop: 6,
  },
}));

export const StyledDeleteIcon = withStyles(DeleteIcon, (theme) => ({
  root: {
    color: "#FF6262",
    marginTop: 6,
  },
}));

export const StyledHorizontalDivider = withStyles(Divider, (theme: Theme) => ({
  root: {
    backgroundColor: "#D4DBE5",
    height: 2,
    width: "100%",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
  },
}));

export const StyledImageIcon = withStyles(ImageIcon, (theme) => ({
  root: {
    color: colors.gray,
    height: theme.typography.pxToRem(24),
    weight: theme.typography.pxToRem(24),
    margin: theme.spacing(4),
  },
}));

export const StyledFileIcon = withStyles(FileCopyIcon, (theme) => ({
  root: {
    color: colors.gray,
    height: theme.typography.pxToRem(24),
    weight: theme.typography.pxToRem(24),
    margin: theme.spacing(4),
  },
}));

export const StyledVerticalDivider = withStyles(Divider, (theme: Theme) => ({
  root: {
    height: "60%",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    backgroundColor: "#D4DBE5",
  },
}));
